<table class="table table-with-border" *ngIf="tableModel">
	<thead>
	<tr data-testid="columnHeadersRow">
		<th scope="col" [className]="columnClassName" *ngFor="let column of tableModel.columns; index as columnIndex"
			[attr.data-testid]="'columnHeader' + columnIndex">
			<ng-container *ngIf="column.columnHeaderText">
				{{ column.columnHeaderText }}
			</ng-container>
			<ng-container *ngIf="column.columnHeaderTemplate">
				<ng-container [ngTemplateOutlet]="column.columnHeaderTemplate"></ng-container>
			</ng-container>
		</th>
	</tr>
	</thead>
	<tbody>
	<tr *ngFor="let item of tableModel.items; index as rowIndex" [attr.data-testid]="'row' + rowIndex">
		<td *ngFor="let column of tableModel.columns index as cellIndex" [attr.data-testid]="'cell' + cellIndex">
			<ng-container *ngIf="column.getValueFunction">
				{{column.getValueFunction(item)}}
			</ng-container>
			<ng-container *ngIf="column.cellTemplate">
				<ng-container [ngTemplateOutlet]="column.cellTemplate"
							  [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
			</ng-container>
		</td>
	</tr>
	</tbody>
</table>
